"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promoThemeStrategy = exports.promoHeightStrategy = exports.alignItemsStrategy = exports.justifyContentStrategy = exports.promoCopySizeArray = exports.promoThemeArray = exports.promoHeightArray = exports.PromoCopySize = exports.PromoTheme = exports.PromoHeight = void 0;

var _const = require("../../const");

var _themeOptions = require("../../helpers/theme-options");

var _justifyContentStrate, _alignItemsStrategy, _promoHeightStrategy, _promoThemeStrategy;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PromoHeight;
exports.PromoHeight = PromoHeight;

(function (PromoHeight) {
  PromoHeight["LARGE"] = "large";
  PromoHeight["SMALL"] = "small";
})(PromoHeight || (exports.PromoHeight = PromoHeight = {}));

var PromoTheme;
exports.PromoTheme = PromoTheme;

(function (PromoTheme) {
  PromoTheme["IMAGE_DARK"] = "image-dark";
  PromoTheme["IMAGE_LIGHT"] = "image-light";
  PromoTheme["WHITE"] = "white";
  PromoTheme["SEASHELL"] = "seashell";
  PromoTheme["MOCASSIN"] = "mocassin";
  PromoTheme["CLARET"] = "claret";
  PromoTheme["BLACK"] = "black";
  PromoTheme["GEM"] = "gem";
})(PromoTheme || (exports.PromoTheme = PromoTheme = {}));

var PromoCopySize;
exports.PromoCopySize = PromoCopySize;

(function (PromoCopySize) {
  PromoCopySize["LARGE"] = "h5";
  PromoCopySize["SMALL"] = "h3";
})(PromoCopySize || (exports.PromoCopySize = PromoCopySize = {}));

var promoHeightArray = Object.values(PromoHeight);
exports.promoHeightArray = promoHeightArray;
var promoThemeArray = Object.values(PromoTheme);
exports.promoThemeArray = promoThemeArray;
var promoCopySizeArray = Object.values(PromoCopySize);
exports.promoCopySizeArray = promoCopySizeArray;
var justifyContentStrategy = (_justifyContentStrate = {}, _defineProperty(_justifyContentStrate, _const.Align.LEFT, 'start'), _defineProperty(_justifyContentStrate, _const.Align.CENTER, 'center'), _defineProperty(_justifyContentStrate, _const.Align.RIGHT, 'end'), _justifyContentStrate);
exports.justifyContentStrategy = justifyContentStrategy;
var alignItemsStrategy = (_alignItemsStrategy = {}, _defineProperty(_alignItemsStrategy, _const.Align.LEFT, 'flex-start'), _defineProperty(_alignItemsStrategy, _const.Align.CENTER, 'center'), _defineProperty(_alignItemsStrategy, _const.Align.RIGHT, 'flex-end'), _alignItemsStrategy);
exports.alignItemsStrategy = alignItemsStrategy;
var promoHeightStrategy = (_promoHeightStrategy = {}, _defineProperty(_promoHeightStrategy, PromoHeight.LARGE, 400), _defineProperty(_promoHeightStrategy, PromoHeight.SMALL, 250), _promoHeightStrategy);
exports.promoHeightStrategy = promoHeightStrategy;
var promoThemeStrategy = (_promoThemeStrategy = {}, _defineProperty(_promoThemeStrategy, PromoTheme.IMAGE_DARK, {
  type: _themeOptions.ThemeType.DARK,
  size: _themeOptions.ThemeSize.FULL,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_promoThemeStrategy, PromoTheme.IMAGE_LIGHT, {
  type: _themeOptions.ThemeType.LIGHT,
  size: _themeOptions.ThemeSize.FULL,
  headline1Color: 'gray800',
  headline2Color: 'gray800'
}), _defineProperty(_promoThemeStrategy, PromoTheme.WHITE, {
  type: _themeOptions.ThemeType.LIGHT,
  size: _themeOptions.ThemeSize.FULL,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_promoThemeStrategy, PromoTheme.SEASHELL, {
  type: _themeOptions.ThemeType.LIGHT,
  size: _themeOptions.ThemeSize.FULL,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_promoThemeStrategy, PromoTheme.MOCASSIN, {
  type: _themeOptions.ThemeType.LIGHT,
  size: _themeOptions.ThemeSize.FULL,
  headline1Color: 'primaryDark',
  headline2Color: 'gray800'
}), _defineProperty(_promoThemeStrategy, PromoTheme.CLARET, {
  type: _themeOptions.ThemeType.DARK,
  size: _themeOptions.ThemeSize.FULL,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_promoThemeStrategy, PromoTheme.BLACK, {
  type: _themeOptions.ThemeType.DARK,
  size: _themeOptions.ThemeSize.FULL,
  headline1Color: 'white',
  headline2Color: 'white'
}), _defineProperty(_promoThemeStrategy, PromoTheme.GEM, {
  type: _themeOptions.ThemeType.DARK,
  size: _themeOptions.ThemeSize.FULL,
  headline1Color: 'white',
  headline2Color: 'white'
}), _promoThemeStrategy);
exports.promoThemeStrategy = promoThemeStrategy;